<template>

<v-sheet :style="bodyMarginStyle +  (!isReady ? 'opacity : 0;' : '')"
         :color="designReady ? EMAIL_CONFIG_COLOR('background') : wsLIGHTCARD"
         width="800"
         class="pt-16"
         style="position: relative;transition: opacity 0.3s ease"
>

  <v-sheet
      :width="!EMAIL_MOBILE_VIEW ? 700 : 320"
      class="mx-auto"
      v-if="designReady"
      :style="emailBodyStyle "
  >
    <email-header-editor
        :config="EMAIL_CONFIG"
        preview
    />

    <email-block-view
        v-for="(block,index) in newsletter.blocks" :key="block"
        :uuid="block"
        :index="index"
        :is-last="index === newsletter.blocks.length - 1"
        :preview="preview"
        @ready="handleReadyBlocks"
        :config="EMAIL_CONFIG"
        :super-admin="superAdmin"
    />

    <email-footer-editor
        :config="EMAIL_CONFIG"
        preview
    />


  </v-sheet>

</v-sheet>
</template>

<script>
import finemailer from "@/modules/finemailer/mixins/finemailer";
import {mapActions} from "vuex";
import newsletterConfig from '@modules/finemailer/assets/json/newsletterConfig.json'
import emailHeaderEditor
  from "@/modules/finemailer/components/emailConstructor/editor/emailHeaderEditor.vue";
import emailFooterEditor
  from "@/modules/finemailer/components/emailConstructor/editor/emailFooterEditor.vue";
import emailBlockView from "@/modules/finemailer/components/emailConstructor/viewer/emailBlockView.vue";

export default {
  name: "emailView",
  components: {
    emailFooterEditor,
    emailHeaderEditor,
    emailBlockView
  },
  mixins : [finemailer],
  props : {
    entity : {
      type : Object,
      default () { return {} }
    },
    uuid : {
      type : String
    },
    preview : {
      type : Boolean,
      default: false
    },
    scale : {},
    superAdmin : {
      type : Boolean,
      default : false
    }
  },
  data() {
    return {
      loading : false,
      newsletter : {
        blocks : []
      },
      designReady : false,
      readyBlocks : 0,
      isReady : 0,
    }
  },
  computed : {

    templatedLoaded() {
      return this.designReady &&  this.readyBlocks === this.newsletter.blocks.length
    },
    bodyMarginStyle() {

      if (!this.designReady) {
        return ''
      }

      let style = ''

      if ( this.EMAIL_CONFIG.body_margin_top) {
        style += `padding-top: ${this.EMAIL_CONFIG.body_margin_top}px;`
      }

      if ( this.EMAIL_CONFIG.body_margin_bottom) {
        style += `padding-bottom: ${this.EMAIL_CONFIG.body_margin_bottom}px;`
      }

      if ( this.scale) {
        style += `scale : ${this.scale};transform-origin: top left;`
      }


      return style
    },
    emailBodyStyle() {
      if (!this.designReady) {
        return ''
      }
      let style = ''
      style += `background-color: ${this.EMAIL_CONFIG_COLOR('email')};`

      if ( this.EMAIL_CONFIG.body_padding_top) {
        style += `padding-top: ${this.EMAIL_CONFIG.body_padding_top}px;`
      }
      if ( this.EMAIL_CONFIG.body_padding_bottom) {
        style += `padding-bottom: ${this.EMAIL_CONFIG.body_padding_bottom}px;`
      }
      if ( this.EMAIL_CONFIG.body_padding_left) {
        style += `padding-left: ${this.EMAIL_CONFIG.body_padding_left}px;`
      }
      if ( this.EMAIL_CONFIG.body_padding_right) {
        style += `padding-right: ${this.EMAIL_CONFIG.body_padding_right}px;`
      }

      if ( this.EMAIL_CONFIG.body_margin_top) {
        style += `margin-top: ${this.EMAIL_CONFIG.body_margin_top}px;`
      }

      if ( this.EMAIL_CONFIG.body_margin_bottom) {
        style += `margin-bottom: ${this.EMAIL_CONFIG.body_margin_bottom}px;`
      }

      return style
    },
    entityUuid() {
      return this.entity.uuid
    }
  },
  watch : {
    templatedLoaded(value) {
      if ( value ) {
        setTimeout(()=> {
          this.isReady = true
        }, 500)
      }
    },
    entityUuid(value) {
      if ( value ) {
        this.prepareExistingDesign()
      }

    },
    uuid(value) {
      if ( value) {
        this.initPage()
      }
    }
  },
  methods : {

    ...mapActions('finemailer' , [
      'GET_NEWSLETTER_DESIGN',
      'GET_NEWSLETTER_DESIGN_SUPERADMIN'
    ]),

    handleReadyBlocks() {
      if ( this.readyBlocks >= this.newsletter.blocks.length ) {
        return
      }
      this.readyBlocks++

    },
    async getDesign() {
      if ( !this.uuid) {
        return
      }
      let result
      if (!this.superAdmin) {
        result = await this.GET_NEWSLETTER_DESIGN(this.uuid)
      } else {
        result = await this.GET_NEWSLETTER_DESIGN_SUPERADMIN(this.uuid)
      }

      if (!result) {
        this.ERROR()
      }

      this.newsletter = this.COPY(result)
      this.$store.state.businessConfig = result.business_config
      this.$store.state.finemailer.selectedNewsletter = result
      result.config.phone = result.business_config.phone
      result.config.address = result.business_config.address
      this.CONFIG = result.config
      this.PREPARE_EMAIL_CONFIG()
      this.designReady = true
    },
    prepareExistingDesign() {
      if ( this.entity && this.entity.uuid ) {
        this.newsletter = this.COPY(this.entity)
        this.CONFIG = this.newsletter.config
        this.designReady = true
      }
    },

    async initPage() {
      this.prepareExistingDesign()
      await this.getDesign()
      this.$emit('body-color' , this.EMAIL_CONFIG_COLOR('background'))
    },

  },
  beforeMount() {
    this.$store.state.finemailer.defaultNewsletterConfig = newsletterConfig
  },
  async mounted() {
    this.initPage()
  },

}
</script>

<style scoped>

</style>